import React from 'react'
import Header, { HeaderLeft } from '../../../layout/Header/Header'

const DashboardHeader = () => {
	return (
		<Header>
			<HeaderLeft>.{/* <Search /> */}</HeaderLeft>
			{/* <CommonHeaderRight afterChildren={<CommonHeaderChat />} /> */}
		</Header>
	)
}

export default DashboardHeader
